import React, { lazy, Suspense, memo } from 'react'
import { LucideProps } from 'lucide-react'
import dynamicIconImports from 'lucide-react/dynamicIconImports'
import { CustomIconsT, STATUS_ICONS } from '@/lib/constants/icons.tsx'

const fallback = (className: string | undefined) => (
  <div className={className ?? 'size-4'} style={{ background: 'transparent' }} />
)

// Cache for loaded icons
const iconCache = new Map<
  DynamicIconT,
  React.LazyExoticComponent<React.ComponentType<LucideProps>>
>()

export type DynamicIconT = keyof typeof dynamicIconImports
export type IconNameT = CustomIconsT | DynamicIconT
export type IconProps = Omit<LucideProps, 'ref'> & {
  icon: IconNameT
}

const Icon = memo(function Icon({ icon, ...props }: IconProps) {
  if (icon in dynamicIconImports) {
    let LucideIcon = iconCache.get(icon as DynamicIconT)

    if (!LucideIcon) {
      const importFunction = dynamicIconImports[icon as DynamicIconT]
        ? dynamicIconImports[icon as DynamicIconT]
        : dynamicIconImports['file-question']

      LucideIcon = lazy(importFunction)
      iconCache.set(icon as DynamicIconT, LucideIcon)
    }

    return (
      <Suspense fallback={fallback(props.className)}>
        <LucideIcon {...props} className={props.className ?? `size-4`} />
      </Suspense>
    )
  }
  return STATUS_ICONS[icon as CustomIconsT]
})

export default Icon
